import { Component } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ENDPOINTS } from '@app/core/constants/endpoints';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false,
})
export class PageNotFoundComponent {
    isAuthenticated = false;
    dashboardUrl = ENDPOINTS.urls.dashboard.base;
    loginUrl = ENDPOINTS.urls.login;

    constructor(private authenticationService: AuthenticationService) {
        this.isAuthenticated = this.authenticationService.isAuthenticated();
    }
}
